<template>
    <div class="mylistwrap">
        <div class="myprogress">
            <div class="courselist" v-for="(item,index) in c_infolist" :key="item.id">
                <div :class="['course',{'hasprogress':item.x_progress.remainsecond>0 && !issmall}]">
                    <div class="title">
                        <router-link class="overparent" :to="item.x_gourl+item.id" :title="$common.langinfo(item.title,item.title_en)"><ffoverdot :title="item.title" :title_en="item.title_en" :needtitle="true"></ffoverdot></router-link>

                        <template v-if="item.x_progress.remainsecond>0 && issmall">
                            ({{item.x_progress.x_remaintime}})
                        </template>
                    </div>
                    <div class="bar" @click="showtopic(index)">
                        <div class="line">
                            <div class="now" :style="{width:item.x_progress.perc+'%'}">
                                <div v-if="item.x_progress.remainsecond>0 && !issmall" class="end">
                                    <router-link v-if="item.x_progress.perc==100" :to="item.x_gourl+item.id">{{$common.dicword('lastlearning')}}<br>{{$common.basic.dateformat(item.x_progress.dateend,'yyyy-MM-dd hh:mm')}}</router-link>
                                    <router-link v-else :to="item.x_gourl+item.id">{{$common.dicword('lastlearning')}}<br>{{$common.basic.dateformat(item.x_progress.dateend,'yyyy-MM-dd hh:mm')}}</router-link>

                                    <span class="arrow"></span>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.x_progress.remainsecond>0 && !issmall" class="start">{{$common.dicword('startlearning')}}<br>{{$common.basic.dateformat(item.x_progress.datebegin,'yyyy-MM-dd hh:mm')}}</div>
                    </div>
                    <div class="time" v-if="!issmall">{{item.x_progress.x_remaintime}}</div>

                </div>
                <transition name="slidedown">
                    <div v-if="item.x_isopen" class="topiclisttran">
                        <div class="topiclist">
                            <div class="topicwrap" v-for="item2 in item.x_children" :key="item2.id">
                                <div class="topic">
                                    <dl>
                                        <dd class="a"><router-link class="overparent" :to="item.x_gourl+item.id+'/'+item2.id" :title="$common.langinfo(item2.title,item2.title_en)"><ffoverdot :title="item2.title" :title_en="item2.title_en" :needtitle="true"></ffoverdot></router-link></dd>
                                        <dd class="b">{{item2.x_remaintime}}</dd>
                                        <dd class="c">
                                            <span class="circle">
                                                <span v-if="item2.x_perc==0" class="ready"></span>
                                                <span v-else-if="item2.x_perc==100" class="done"></span>
                                                <template v-else>
                                                    <span class="doing" :style="{transform: 'rotate('+(item2.x_perc*3.6)+'deg)'}"></span>
                                                    <span :class="[item2.x_perc<=50?'fanless':'fanmore']"></span>
                                                </template>
                                            </span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>

            <div class="memnorecord" v-if="c_infolist.length==0 && isload">{{$common.dicword('norecord')}}</div>
        </div>

    </div>

</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin"

    export default {
        name: 'Cprogress',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tea_my_progress'
            };
        },
        methods: {
            getdata: function () {
                this.isload = false;
                this.$common.post(this.postjson, res => {
                    this.isload = true;
                    this.$common.each(res.infodataprogress, (item) => {
                        item.x_remaintime = this.$common.basic.chint2time(Math.round(item.remainsecond / 60));
                    });

                    this.$common.each(res.infodatacourse, (item) => {
                        item.x_progress = this.$common.basic.fffind((res.infodataprogress || []), 'courseid', item.id);
                        item.x_isload = false;
                        item.x_isopen = false;
                        item.x_gourl = '/course/';
                    });
                    this.infolist = res.infodatacourse;
                });
            },
            showtopic: function (v) {

                if (!this.infolist[v].x_isload) {
                    let jsondata = { 'postdata': { 'act': 'tea_my_progress_topic', 'id': this.infolist[v].id, 'data': { 'stuid': this.stuid } }, 'msg': '' };
                    this.$common.post(jsondata, res => {
                        this.$common.each(res.infodata, (item) => {

                            item.x_learntime = '';
                            item.x_perc = 0;
                            let pro = this.$common.basic.fffind((res.infodataprogress || []), 'topicid', item.id);
                            if (this.$common.basic.isobjexist(pro)) {
                                item.x_perc = pro.perc;
                                //item.x_learntime = this.$common.basic.dateformat(pro.datebegin, 'yyyy-MM-dd hh:mm') + '/' + this.$common.basic.dateformat(pro.dateend, 'yyyy-MM-dd hh:mm');
                                item.x_remaintime = this.$common.basic.chint2time(Math.round(pro.remainsecond / 60));
                            }

                        });
                        this.$set(this.infolist[v], 'x_children', res.infodata);
                        this.infolist[v].x_isopen = !this.infolist[v].x_isopen;
                        this.infolist[v].x_isload = true;
                    });
                }
                else {
                    this.infolist[v].x_isopen = !this.infolist[v].x_isopen;
                }

            }
        }
    }
</script>
